const { apiVer4 } = require('../../apis/api.v4.x')
const { ApiTagVer4 } = require('../../tags')

const getSettings = apiVer4.injectEndpoints({
  endpoints: (builder) => ({
    settings: builder.query({
      query: () => ({
        url: '/api/Webs/settings',
        method: 'GET',
      }),
      providesTags: [ApiTagVer4.Web],
    }),
  }),
})

export const useQueryGetSettings = getSettings.useSettingsQuery
